export default __webpack_public_path__ + "static/media/03.9c071748.png";